<template>
    <ModalWrapper v-model="isShowModal" :subtitle="subtitle">
        <template v-slot:title>
            {{ title }}
        </template>
        <template v-slot:content>
            <v-form ref="form" data-cy="hotel-point-form">
                <v-text-field
                    v-model="searchName"
                    :label="$t('search_by_name')"
                    variant="outlined"
                    density="compact"
                    data-cy="name"
                    hide-details
                    @update:model-value="search()"
                />
                <v-data-table
                    v-model="selectedPoints"
                    :headers="useHeaders"
                    :items="filteredContracts"
                    :items-per-page-options="useTableOptions(filteredContracts?.length)"
                    disable-sort
                    density="compact"
                    class="elevation-1"
                    data-cy="table"
                    show-select
                    :hide-default-footer="filteredContracts?.length < 10"
                />
            </v-form>
        </template>
        <template v-slot:btns>
            <v-btn
                data-cy="save"
                :disabled="isLoading || !contracts?.length"
                variant="flat"
                @click="emit('save', {selectedPoints, contracts})"
            >
                {{ $t('apply') }}
            </v-btn>
        </template>
    </ModalWrapper>
</template>
<script setup lang="ts">
    import {useTableOptions} from '~/composables/helpers'

    const props = defineProps<{
        selectedPoint: any
        title?: string
        subtitle?: string
    }>()

    const isShowModal = defineModel<boolean>({
        default: false,
    })

    const isLoading = ref<boolean>(false)
    const contracts = ref([])
    const filteredContracts = ref([])
    const searchName = ref<string>('')
    const selectedPoints = ref<number[]>([])

    const emit = defineEmits<{
        (e: 'save', value): void
        (e: 'cancel'): void
    }>()

    const app = useNuxtApp()
    const {t} = useI18n()

    watch(isShowModal, async () => {
        if (isShowModal.value) {
            await loadData()
            selectedPoints.value = props.selectedPoint?.hotelIds || []
        } else {
            contracts.value = []
        }
    })

    async function loadData(): Promise<void> {
        try {
            isLoading.value = true
            const {countryId, cityId} = props.selectedPoint
            const rq = {countryId, cityId}
            clean(rq)
            const {ownProductContracts} = await app.$api.ownAccommodationContracts.get(rq)
            contracts.value = ownProductContracts.sort((a, b) => a.name.localeCompare(b.name))
            filteredContracts.value = ownProductContracts
        } catch (e) {
            contracts.value = []
        } finally {
            isLoading.value = false
        }
    }

    const useHeaders = computed(() => {
        return [{title: t('hotel_name'), value: 'name'}]
    })

    const search = () => {
        filteredContracts.value = contracts.value.filter(({name}) =>
            name.toUpperCase().includes(searchName.value.toUpperCase())
        )
    }
</script>
